import { Fold, Traversal, Lens } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Link from "@discovery/sonic-api-ng/lib/api/cms/links";
const oneToOneRelationships = { cmpContextLink: Link.Resource.target };
export const _superstarRails = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((attributes, image, route) => ({
    route: route,
    name: M.fromMaybe(attributes.title, ""),
    image: image,
    packages: "",
    id: "",
    videoType: M.of(""),
    packagesM: M.of([""]),
}), Optics._Col2Attributes, Fold.compose(Optics._Col2Items, Optics._ColItem2Image, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes")), Fold.compose(Fold.mapF(Res.addNewRelationships(oneToOneRelationships)), Res._Rel("cmpContextLink"), Res._Rel("linkedContentRoutes"), Res._ForEach(), Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url"))));

